// flashPath.ts — where a Flash (video of 60 s or less, formerly "Short") opens. The old
// /videos/shorts/:id addresses redirect here (router.tsx), so shared links keep working.
export const flashPath = (id: string) => `/videos/flash/${encodeURIComponent(id)}`;
